<template>
    <div>
        <PageHeader>
            {{ $t('productCatalog') }}
            <template #side>
                <div class="d-flex gap-3">
                    <TimeRangeCalendar v-model="timeRange" />
                </div>
            </template>
        </PageHeader>
        <div class="d-flex gap-4">
            <div class="width-min-300 flex-grow-1 flex-basis-0">
                <ButtonIcon icon="plus" class="mb-4" @click="showModalFormProduct()">{{ $t('addNewProduct') }}</ButtonIcon>
                <ModalFormProduct />
                <ProductsTree ref="ProductsTree" :key="spaceId" @select="select" />
            </div>
            <div v-if="node" class="flex-grow-2 flex-basis-0">
                <CategoryStats v-if="node.type === 'category'" :item="item" />
                <ProductStats v-if="node.type === 'product'" :item="item" />
            </div>
            <div v-else class="flex-grow-1 flex-basis-0">
                <b-alert show variant="light" class="text-center m-3 font-weight-bold">{{ $t('chooseACategoryOrProductToSeeTheDetails') }}</b-alert>
            </div>
        </div>
    </div>
</template>



<script>
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';
    import ProductsTree from './parts/ProductsTree.vue';
    import CategoryStats from './parts/CategoryStats.vue';
    import ProductStats from './parts/ProductStats.vue';
    import ModalFormProduct from './parts/ModalFormProduct.vue';

    export default {
        name: 'ProductCatalog',
        components: {
            TimeRangeCalendar,
            ProductsTree,
            CategoryStats,
            ProductStats,
            ModalFormProduct,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
                node: null,
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            item() {
                return { id: this.node.entityId, name: this.node.text };
            },
        },
        watch: {
            spaceId() {
                this.node = null;
            },
        },
        methods: {
            select(node) {
                this.node = node;
            },
            showModalFormProduct() {
                this.$root.$emit('bv::show::modal', 'modal-form-space-producer-product');
            },
        },
    };
</script>
